import CommonBulkUpload from "@components/BulkUpload";
import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import ImportPopup from "./importPopup";
import { useNavigate } from "react-router-dom";
import {
  exportLegislation,
  exportLegislationRule,
} from "@services/list-management.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { handleDownloadOnClick } from "@_common/downloadfile";
import DownloadSubheaderSvgComponent from "../../assets/svg-components/sub-header/download";
import ReactTooltip from "react-tooltip";

function BulkDownload(props: any) {
  const navigate = useNavigate();
  const { dropdownOptions, url, type } = props;

  const handleNavigateLogs = (name: string) => {
    switch (name) {
      case "LEGISLATION":
        return handleExport("LEGISLATION");
      case "LEGISLATION_RULE":
        return handleExport("LEGISLATION_RULE");
      default:
        return null;
    }
  };

  const handleExport = async (name: string) => {
    if (name === "LEGISLATION") {
      let payload: any = {};
      let queryRequest = QueryRequestHelper(payload);
      try {
        let resp = await exportLegislation(queryRequest);
        if (resp) {
          let URL = getValue(resp, `data.downloadUrl`, "");
          if (URL) {
            handleDownloadOnClick(URL, "legislation_report");
          }
        }
      } catch (error) {}
    }
    if (name === "LEGISLATION_RULE") {
      let payload: any = {};
      let queryRequest = QueryRequestHelper(payload);
      try {
        let resp = await exportLegislationRule(queryRequest);
        if (resp) {
          let URL = getValue(resp, `data.downloadUrl`, "");
          if (URL) {
            handleDownloadOnClick(URL, "legislation_rule_report");
          }
        }
      } catch (error) {}
    }
  };
  return (
    <div>
      <ReactTooltip id="subHeaderDownload" effect="solid" place="bottom" >
        Download
      </ReactTooltip>
      <UncontrolledDropdown>
        <DropdownToggle className="icons-btn p-0" data-tip data-for="subHeaderDownload">
          {/* <div className="add-filter-wrapper__filter-container">
            <div className="cursor-pointer">
              <img
                src="/images/download-gray.svg"
                className="img-fluid add-filter-wrapper__upload-image"
              />
              <p className="add-filter-wrapper__filter-title">EXPORT</p>
            </div>
          </div> */}
          <DownloadSubheaderSvgComponent />
        </DropdownToggle>
        <DropdownMenu>
          {getValue(dropdownOptions, `length`, 0) > 0 &&
            dropdownOptions.map((item: object) => {
              return (
                <DropdownItem
                  onClick={() => {
                    handleNavigateLogs(getValue(item, `value`, ""));
                  }}
                >
                  {getValue(item, `label`, "")}
                </DropdownItem>
              );
            })}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
}

export default BulkDownload;
